/** @format */

import { useState, useLayoutEffect, useEffect } from 'react';

const XL = 4;
const LG = 3;
const MD = 2;
const SM = 1;

const useRWD = () => {
	const useIsomorphicLayoutEffect =
		typeof window !== 'undefined' ? useLayoutEffect : useEffect;
	const [RWD, setRWD] = useState('XL');
	const [size, setSize] = useState(XL);

	const handleRWD = () => {
		if (typeof window !== 'undefined') {
			if (window.innerWidth > 1199) {
				setRWD('XL');
				setSize(XL);
			} else if (window.innerWidth > 991) {
				setRWD('LG');
				setSize(LG);
			} else if (window.innerWidth > 767) {
				setRWD('MD');
				setSize(MD);
			} else {
				setRWD('SM');
				setSize(SM);
			}
		}
	};

	useIsomorphicLayoutEffect(() => {
		window.addEventListener('resize', handleRWD);
		handleRWD();

		return () => {
			window.removeEventListener('resize', handleRWD);
		};
	}, []);

	return {
		RWD,
		isXL: RWD === 'XL',
		isLG: RWD === 'LG',
		isMD: RWD === 'MD',
		isSM: RWD === 'SM',
		size,
		XL,
		LG,
		MD,
		SM
	};
};

export default useRWD;
